 <template>
  <div class="d-flex align-center flex-column pt-10">
    <h2>Συνοδευτικό δελτίο εργαστηριακού ελέγχου</h2>
    <h2>Laboratory Test Accompanying Card</h2>
    <v-form @submit.prevent="submit" class="d-flex flex-column align-center">
        <p>ΠΡΟΣ ΔΙΑΓΝΩΣΤΙΚΟ ΕΡΓΑΣΤΗΡΙΟ</p>
      <div class="d-flex justify-center">
        
        <div class="d-flex flex-column flex-grow-1 px-10">
          <p>Συμπληρώνεται απο τον ΙΑΤΡΟ</p>
          <v-text-field class="flex-grow-0" label="Τόπος δειγματοληψίας" v-model="medical.doctor.place"></v-text-field>
          <p class="caption">Αναγνωριστικό ομαδοποίησης ελέγχου (πχ αριθμός πτήσης, δομή)</p>
          <v-radio-group class="flex-grow-0" v-model="medical.doctor.type">
            <v-radio label="Πτήση" value="flight"></v-radio>
            <v-radio label="Πλωτό μέσο" value="sea"></v-radio>
            <v-radio label="Δομή" value="domh"></v-radio>
            <v-radio label="Άλλο" value="other"></v-radio>
          </v-radio-group>
          <v-text-field class="flex-grow-0" label="Αναγνωριστικό" v-model="medical.doctor.typeId"></v-text-field>

          <v-text-field class="flex-grow-0" label="Ονοματεπώνυμο ιατρού" v-model="medical.doctor.name"></v-text-field>
          <v-text-field class="flex-grow-0" label="Τηλ. επικοινωνίας" v-model="medical.doctor.phone"></v-text-field>
          <v-radio-group class="flex-grow-0" label="Δειγμα" v-model="medical.doctor.sample">
            <v-radio label="Φαρυγγικό επίχρισμα (Pharyngeal swab)" value="pharyngeal"></v-radio>
            <v-radio label="Ρινικό επίχρισμα (Nasal swab)" value="nasal"></v-radio>
          </v-radio-group>
          <v-text-field class="flex-grow-0" label="Ημερομηνία λήξης" v-model="medical.doctor.expirationDate"></v-text-field>
        </div>

        <div class="d-flex flex-column flex-grow-1 px-10">
            <p>Συμπληρώνεται απο το ΕΡΓΑΣΤΗΡΙΟ</p>
            <v-text-field class="flex-grow-0" label="Εβδομάδα" v-model="medical.lab.week"></v-text-field>
            <v-text-field class="flex-grow-0" label="A/A δείγματος" v-model="medical.lab.aa"></v-text-field>
            <v-text-field class="flex-grow-0" label="Ημερομηνία παραλαβής απο το εργαστήριο" v-model="medical.lab.dateTake"></v-text-field>
        </div>
      </div>

   



      <v-btn color="primary" type="submit">ΕΠΟΜΕΝΟ</v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
    data(){
        return{ 
            medical: {
                doctor: {
                    place: this.$store.state.frontDesk.editingTouristTest?.medical?.doctor?.place,
                    type: this.$store.state.frontDesk.editingTouristTest?.medical?.doctor?.type,
                    typeId: this.$store.state.frontDesk.editingTouristTest?.medical?.doctor?.typeId,
                    name: this.$store.state.frontDesk.editingTouristTest?.medical?.doctor?.name,
                    phone: this.$store.state.frontDesk.editingTouristTest?.medical?.doctor?.phone,
                    sample: this.$store.state.frontDesk.editingTouristTest?.medical?.doctor?.sample,
                    expirationDate: this.$store.state.frontDesk.editingTouristTest?.medical?.doctor?.expirationDate
                },
                lab: {
                    week: this.$store.state.frontDesk.editingTouristTest?.medical?.lab?.week,
                    aa: this.$store.state.frontDesk.editingTouristTest?.medical?.lab?.aa,
                    dateTake: this.$store.state.frontDesk.editingTouristTest?.medical?.lab?.dateTake
                }
            }
        }
    },

    methods: {
        submit(){
            const credentials = {
                medical: this.medical
            }

            this.$store.dispatch('editTouristTestThird', credentials)
        }
    }
}
</script>
